import { render, staticRenderFns } from "./LicenseOfferModal.vue?vue&type=template&id=2beb9437&scoped=true&"
import script from "./LicenseOfferModal.vue?vue&type=script&lang=js&"
export * from "./LicenseOfferModal.vue?vue&type=script&lang=js&"
import style0 from "./LicenseOfferModal.vue?vue&type=style&index=0&id=2beb9437&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb9437",
  null
  
)

export default component.exports